/* eslint-disable no-unused-vars */
// used to set banners to their vaild types
enum BannerStyle {
	Success = "success",
	Error = "critical"
}

export default BannerStyle;
